/** The query parameter of the payment link carrying its signature; it is lifted out of the URL on arrival. */
export const SPAN_PAYMENT_LINK_SIGNATURE_PARAM = 'signature';

/** Keeps, per span, the signature lifted out of the URL for the life of the tab. */
export const SPAN_PAYMENT_LINK_SIGNATURE_STORAGE_KEY_PREFIX = 'reservation.spanPaymentLinkSignature.';

export const SPAN_PAYMENT_LINK_CONFIRMATION_POLL_INTERVAL_MILLISECONDS = 3_000;
// Mirrors the backend's `reservation.extension_lock.ttl_minutes`, for which the payment of the span stays valid.
export const SPAN_PAYMENT_LINK_CONFIRMATION_TIMEOUT_MILLISECONDS = 5 * 60 * 1_000;

/** Marks, across the PayNow round trip, that the payment was started from the payment link. */
export const SPAN_PAYMENT_LINK_REDIRECT_STORAGE_KEY = 'reservation.spanPaymentLinkRedirect';
